import { render } from "./LicenceConfirmModal.vue?vue&type=template&id=150bd71c"
import script from "./LicenceConfirmModal.vue?vue&type=script&lang=js"
export * from "./LicenceConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__